/**
 * @file technical-details.tsx
 * @module app/modules/uProcure/products/edit-product-variant/technical-details
 * @description Implements the technical details interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { useEffect, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { CustomSelectWhite } from '../../../../custom/Select/CustomSelectWhite';
import {
  DateSelection,
  MultiLineText,
  MultiSelection,
  SingleLineText,
  SingleSelection,
} from '../../../../../utils/constants';
import clsx from 'clsx';
import CustomDatePicker from '../../../../custom/DateRange/DatePicker';
const TechnicalDetails = (props: any) => {
  const [startDate, setStartDate] = useState<any>(new Date());
  const [generalData, setGeneralData] = useState<any>(props.generalData);
  const [generalDataValidation, setGeneralDataValidation] = useState<any>(
    props.validations
  );
  const [changed, setChanged] = useState<boolean>(
    props.initData.techInfoSeparated
  );
  const initData: any = Object.freeze(props.initData.defaultTechnicalFields);
  const handleChange = (value: any, techIndex: number) => {
    let temp: any = { ...generalData };
    let validationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    if (value.length > 0) {
      validationTemp.technicalInfo[techIndex]['valid'] = false;
    } else {
      validationTemp.technicalInfo[techIndex]['valid'] = true;
    }
    // temp[name] = value;
    // temp.defaultTechnicalFields[techIndex] = { answer: value };
    temp.defaultTechnicalFields[techIndex]['answer'] = value;
    if (
      initData[techIndex]['answer'] &&
      initData[techIndex]['answer'].length !==
        temp.defaultTechnicalFields[techIndex]['answer'].length
    ) {
      setChanged(true);
    }
    setGeneralDataValidation(validationTemp);
    setGeneralData(temp);
  };
  const handleMultipleChange = (event: any, techIndex: number) => {
    let temp: any = JSON.parse(JSON.stringify({ ...generalData }));
    let data: any = [];
    let validationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    if (event.length) {
      validationTemp.technicalInfo[techIndex]['valid'] = false;
    } else {
      validationTemp.technicalInfo[techIndex]['valid'] = true;
    }
    event.map((val: any) => {
      return data.push(val._id);
    });
    setGeneralDataValidation(validationTemp);
    temp.defaultTechnicalFields[techIndex]['selectedOptions'] = data;
    if (
      initData[techIndex]['selectedOptions'].length !==
      temp.defaultTechnicalFields[techIndex]['selectedOptions'].length
    ) {
      setChanged(true);
    }
    setGeneralData(temp);
  };
  const handleSingleChange = (event: any, techIndex: number) => {
    let temp: any = { ...generalData };
    let data: any = [];
    let validationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    validationTemp.technicalInfo[techIndex]['valid'] = false;
    data.push(event._id);
    temp.defaultTechnicalFields[techIndex]['selectedOptions'] = data;
    if (
      initData[techIndex]['selectedOptions'].length !==
      temp.defaultTechnicalFields[techIndex]['selectedOptions'].length
    ) {
      setChanged(true);
    }
    setGeneralDataValidation(validationTemp);
    setGeneralData(temp);
  };
  const handleTechnicalInfoSeperated = (value: boolean) => {
    let temp: any = { ...generalData };
    let data: any = [];
    let validationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    validationTemp.techInfoSeparated = false;
    temp.techInfoSeparated = value;
    setGeneralDataValidation(validationTemp);
    setGeneralData(temp);
  };
  useEffect(() => {
    let result = initData.filter(
      (o1: any) =>
        !generalData.defaultTechnicalFields.some((o2: any) => {
          if (o2.type === SingleLineText || o2.type === MultiLineText) {
            return o1.answer === o2.answer;
          } else {
            return (
              JSON.stringify(o2.selectedOptions) ===
              JSON.stringify(o1.selectedOptions)
            );
          }
        })
    );
    if (result.length) {
      setChanged(true);
    } else {
      if (props.initData.techInfoSeparated)
        setChanged(props.initData.techInfoSeparated);
      else setChanged(false);
    }
    props.onGeneralDataChange(generalData);
  }, [generalData, props]);
  const handleDateChange = (value: any, techIndex: number) => {
    setStartDate(value);
    let temp: any = { ...generalData };
    let validationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    if (value.length > 0) {
      validationTemp.technicalInfo[techIndex]['valid'] = false;
    } else {
      validationTemp.technicalInfo[techIndex]['valid'] = true;
    }
    // temp[name] = value;
    // temp.defaultTechnicalFields[techIndex] = { answer: value };
    temp.defaultTechnicalFields[techIndex]['answer'] = value;
    setGeneralDataValidation(validationTemp);
    setGeneralData(temp);
  };
  useEffect(() => {
    props.onValidationChange(generalDataValidation);
  }, [generalDataValidation]);
  return (
    <>
      <Card className="bg-light mb-6 mb-xl-9 border">
        <div className="card-body">
          {generalData.defaultTechnicalFields.length > 0 ? (
            generalData.defaultTechnicalFields.map(
              (techVal: any, techIndex: number) => {
                if (techVal.type === SingleLineText) {
                  return (
                    <Row className={clsx('align-items-center mb-5')}>
                      <Col lg={2}>
                        <label
                          htmlFor=""
                          className="fs-16 fw-500 mb-lg-0 mb-3"
                        >
                          {techVal?.name}
                        </label>
                      </Col>
                      <Col lg={10}>
                        <input
                          type="text"
                          className={clsx(
                            'form-control form-control-custom bg-white',
                            generalDataValidation.technicalInfo[techIndex][
                              'valid'
                            ]
                              ? 'border-danger'
                              : ''
                          )}
                          placeholder="Type here…"
                          value={techVal?.answer}
                          onChange={(event: any) => {
                            handleChange(
                              event.target.value.trimStart(),
                              techIndex
                            );
                          }}
                        />
                      </Col>
                    </Row>
                  );
                }
                if (techVal.type === SingleSelection) {
                  return (
                    <Row className="align-items-center mb-5">
                      <Col lg={2}>
                        <label
                          htmlFor=""
                          className="fs-16 fw-500 mb-lg-0 mb-3"
                        >
                          {techVal?.name}
                        </label>
                      </Col>
                      <Col lg={10}>
                        <CustomSelectWhite
                          options={techVal.options}
                          getOptionLabel={(option: any) => {
                            return option.title;
                          }}
                          border={
                            generalDataValidation.technicalInfo[techIndex][
                              'valid'
                            ]
                              ? '#e55451'
                              : ''
                          }
                          defaultValue={techVal.options.find((val: any) => {
                            return (
                              techVal.selectedOptions &&
                              techVal.selectedOptions.includes(val._id)
                            );
                          })}
                          isMulti={false}
                          onChange={(event: any) => {
                            handleSingleChange(event, techIndex);
                          }}
                          isSearchable={false}
                        />
                      </Col>
                    </Row>
                  );
                }
                if (techVal.type === MultiLineText) {
                  return (
                    <Row className="align-items-center mb-5">
                      <Col
                        lg={2}
                        className="align-self-lg-start mt-lg-2"
                      >
                        <label
                          htmlFor=""
                          className="fs-16 fw-500 mb-lg-0 mb-3"
                        >
                          {techVal?.name}
                        </label>
                      </Col>
                      <Col lg={10}>
                        <Form.Control
                          className={clsx(
                            'form-control-custom border bg-white',
                            generalDataValidation.technicalInfo[techIndex][
                              'valid'
                            ]
                              ? 'border-danger'
                              : ''
                          )}
                          placeholder="Type here…"
                          as="textarea"
                          rows={4}
                          value={techVal?.answer}
                          onChange={(event: any) => {
                            handleChange(
                              event.target.value.trimStart(),
                              techIndex
                            );
                          }}
                        />
                      </Col>
                    </Row>
                  );
                }
                if (techVal.type === MultiSelection) {
                  return (
                    <Row className="align-items-center mb-5">
                      <Col lg={2}>
                        <label
                          htmlFor=""
                          className="fs-16 fw-500 mb-lg-0 mb-3"
                        >
                          {techVal?.name}
                        </label>
                      </Col>
                      <Col lg={10}>
                        <CustomSelectWhite
                          // options={techVal.options}
                          value={techVal.selectedOptions
                            .map((selectedOptionId: any) => {
                              const option = techVal.options.find(
                                (option: any) => option._id === selectedOptionId
                              );
                              if (option) {
                                return {
                                  title: option.title,
                                  label: option.title,
                                  _id: option._id,
                                  value: option._id,
                                };
                              }
                              return null;
                            })
                            .filter((option: any) => option !== null)}
                          // getOptionLabel={(option: any) => {
                          //   return option.title;
                          // }}
                          // // value={
                          // //   techVal.selectedOptions &&
                          // //   techVal.selectedOptions.map(
                          // //     (optionVal: any, optionIndex: number) => {
                          // //       return optionVal;
                          // //     }
                          // //   )
                          // // }
                          // isMulti={true}
                          // onChange={(event: any) => {
                          //   handleMultipleChange(event, techIndex);
                          // }}
                          // hideSelectedOptions={false}
                          border={
                            generalDataValidation.technicalInfo[techIndex][
                              'valid'
                            ]
                              ? '#e55451'
                              : ''
                          }
                          options={
                            techVal.options?.length &&
                            techVal.options.map((val: any, index: number) => {
                              return {
                                title: val.title,
                                label: val.title,
                                _id: val._id,
                                value: val._id,
                              };
                            })
                          }
                          loadingMessage={'Fetching Data'}
                          isMulti={true}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ): void => handleMultipleChange(e, techIndex)}
                          isSearchable={false}
                        />
                      </Col>
                    </Row>
                  );
                }
                if (techVal.type === DateSelection) {
                  return (
                    <Row className={clsx('align-items-center mb-5')}>
                      <Col lg={2}>
                        <label
                          htmlFor=""
                          className="fs-16 fw-500 mb-lg-0 mb-3"
                        >
                          {techVal?.name}
                        </label>
                      </Col>
                      <Col lg={10}>
                        {/* <input
                          type="text"
                          className={clsx(
                            "form-control form-control-custom bg-white",
                            generalDataValidation.defaultTechnicalFields[
                              techIndex
                            ]["valid"]
                              ? "border-danger"
                              : ""
                          )}
                          placeholder="Type here…"
                          value={techVal?.answer}
                          onChange={(event: any) => {
                            handleChange(
                              event.target.value.trimStart(),
                              techIndex
                            );
                          }}
                        /> */}
                        <CustomDatePicker
                          className={clsx(
                            'bg-white min-h-50px text-dark min-w-md-204px min-w-175px '
                          )}
                          selected={
                            techVal.answer && techVal.answer !== 'undefined'
                              ? new Date(techVal.answer)
                              : new Date()
                          }
                          onChange={(e: any): void =>
                            handleDateChange(e, techIndex)
                          }
                          // selectsRange
                          startDate={
                            techVal.answer && techVal.answer !== 'undefined'
                              ? new Date(techVal.answer)
                              : new Date()
                          }
                          dateFormat="dd/MM/yyyy"
                          showFullMonthYearPicker
                          inputTextBG="bg-white"
                        />
                      </Col>
                    </Row>
                  );
                }
              }
            )
          ) : (
            <>
              <div className="h-150px w-100 align-items-center d-flex justify-content-center">
                <span className="fs-22 text-dark fw-600">
                  No technical fields available
                </span>
              </div>
            </>
          )}
        </div>
      </Card>
      {changed ? (
        <Card className="bg-light mb-6 mb-xl-9 border">
          <Card.Header className="border-bottom-0">
            <Card.Title className="fs-20 fw-600">
              You’ve made changes to the technical details.
            </Card.Title>
          </Card.Header>
          <Card.Body className="pt-0">
            <Row>
              <Col xs="auto">
                <div className="form-check form-check-custom form-check-solid form-check-lg">
                  <input
                    className="form-check-input me-2"
                    type="checkbox"
                    value=""
                    id="flexCheckboxLg"
                    checked={generalData.techInfoSeparated}
                    onClick={() => {
                      handleTechnicalInfoSeperated(
                        !generalData.techInfoSeparated
                      );
                    }}
                  />
                  <label
                    className="form-check-label fs-16 fw-600 text-dark"
                    htmlFor="flexCheckboxLg"
                  >
                    Use separate technical details for this variant
                  </label>
                </div>
              </Col>
              <Col xs="auto">
                <div className="form-check form-check-custom form-check-solid form-check-lg">
                  <input
                    className="form-check-input me-2"
                    type="checkbox"
                    value=""
                    id="flexCheckboxLg"
                    checked={!generalData.techInfoSeparated}
                    onClick={() => {
                      handleTechnicalInfoSeperated(
                        !generalData.techInfoSeparated
                      );
                    }}
                  />
                  <label
                    className="form-check-label fs-16 fw-600 text-dark"
                    htmlFor="flexCheckboxLg"
                  >
                    Use master product technical details
                  </label>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ) : (
        <></>
      )}
    </>
  );
};
export default TechnicalDetails;
